export default "__VITE_PUBLIC_ASSET__99f6b7ad__"